export default __webpack_public_path__ + "static/media/gallery_13.99e1823e.jpg";